import type { Hotkeys } from 'owa-hotkeys';
import { isMac } from 'owa-user-agent/lib/userAgent';

/**
 *  Single source of truth for the two platform-specific Copilot DAB keyboard shortcuts:
 *  1. Mac:     Cmd+Ctrl+I  (⌘+ctrl+i)
 *  2. Windows: Alt+C       (alt+c)
 *
 *  Two representations are needed for the two use cases:
 *  1. Displaying the hotkey string in the UI = `getHotkey`
 *  2. Verifying the hotkey has been input = `matchesHotkey`
 */

/**
 * Returns the Copilot DAB shortcut as a string to display in the UI (ie: "Shortcuts" dialog)
 */
export const getHotkey = (): Hotkeys => {
    const mac = '\u2318+ctrl+i';
    const windows = 'alt+c';

    return isMac() ? mac : windows;
};

/**
 * Returns `true` when the provided `KeyboardEvent` matches the Copilot DAB shortcut
 */
export const matchesHotkey = (event: KeyboardEvent): boolean => {
    const { altKey, code, ctrlKey, metaKey, shiftKey } = event;

    const mac = metaKey && ctrlKey && code === 'KeyI' && !altKey && !shiftKey;
    const windows = altKey && code === 'KeyC' && !ctrlKey && !metaKey && !shiftKey;

    return isMac() ? mac : windows;
};
